import { render, staticRenderFns } from "./IconDashboard.vue?vue&type=template&id=6d33a5ee"
import script from "./IconDashboard.vue?vue&type=script&lang=ts"
export * from "./IconDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports